// Manageleads.js
import React, { useEffect, useState, useCallback, useContext, useMemo, useRef } from 'react';
import './Leads.css'; // Make sure your CSS file is correctly linked
import Url from '../Url'; // Assuming Url.Url points to your API base URL
import { useNavigate, useLocation } from 'react-router-dom';
import { LoginContext } from '../Login/LoginContext';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faHistory, faTimes, faSearch, faEdit, faTable, faThLarge, faInfoCircle,
    faCalendarAlt,
    faCube,
    faClock,
    faHourglassHalf,
    faPhone,
    faStickyNote,
    faStar,
    faStar as faStarEmpty, // Renamed to avoid conflict if faStar is used for filled star
    faFilePdf,
    faTag, // New icon for status edit
    faShareNodes // New icon for share functionality
} from '@fortawesome/free-solid-svg-icons';
import * as XLSX from 'xlsx';
import html2pdf from 'html2pdf.js';

// Import react-datepicker
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'; // Don't forget to import the CSS!
// Import react-window's FixedSizeList and react-virtualized-auto-sizer
import { FixedSizeGrid as Grid } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';

export default function Manageleads() {
    // State variables
    const [loadingLeads, setLoadingLeads] = useState(true);
    const [leads, setLeads] = useState([]);
    const { loginResult } = useContext(LoginContext);
    const [searchQuery, setSearchQuery] = useState('');
    // Ensure user_id is properly handled if loginResult can be null or undefined
    const user_id = loginResult?.user_id;
    const navigate = useNavigate();
    const location = useLocation();

    const [showCallHistory, setShowCallHistory] = useState(false);
    const [selectedLeadForHistory, setSelectedLeadForHistory] = useState(null);

    const [filterStatus, setFilterStatus] = useState('All'); // Initial filter status

    const [showImportModal, setShowImportModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [importing, setImporting] = useState(false);

    const [viewType, setViewType] = useState('Box'); // Default to 'Box' view
    const [showViewDropdown, setShowViewDropdown] = useState(false);

    // NEW STATE FOR STATUS UPDATE AND FOLLOW-UP MODAL
    const [showStatusUpdateModal, setShowStatusUpdateModal] = useState(false);
    const [selectedLeadForStatusUpdate, setSelectedLeadForStatusUpdate] = useState(null); // Used for status updates
    const [callStatuses, setCallStatuses] = useState([]);
    const [loadingStatuses, setLoadingStatuses] = useState(true);
    const [statusError, setStatusError] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [note, setNote] = useState('');
    const [date, setDate] = useState(new Date()); // Initialize with current date
    const [rating, setRating] = useState(0);
    const [showStatusModal, setShowStatusModal] = useState(false);


    // NEW STATE FOR LIVE PRODUCT FUNCTIONALITY (FROM Leads.js)
    const [showProductModal, setShowProductModal] = useState(false);
    const [liveProducts, setLiveProducts] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(true);
    const [productError, setProductError] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [newProductName, setNewProductName] = useState(''); // Holds the actual new product name

    // New state for the dedicated "Other" product name input popup
    const [showNewProductPopup, setShowNewProductPopup] = useState(false);
    const [tempNewProductName, setTempNewProductName] = useState(''); // To hold value in the temporary popup

    // New state for product search within the modal
    const [productSearchTerm, setProductSearchTerm] = useState('');

    // NEW STATE FOR WHATSAPP TEMPLATES (original, now holds only 'WhatsApp Share' templates)
    const [showWhatsappTemplatesModal, setShowWhatsappTemplatesModal] = useState(false); // This is for templates with status_template: "WhatsApp Share"
    const [whatsappTemplates, setWhatsappTemplates] = useState([]); // Will hold templates with status_template: "WhatsApp Share"
    const [loadingWhatsappTemplates, setLoadingWhatsappTemplates] = useState(true);
    const [whatsappTemplateError, setWhatsappTemplateError] = useState(null);
    const [selectedWhatsappTemplate, setSelectedWhatsappTemplate] = useState(null); // This is for the template selected for "WhatsApp Share"

    // NEW STATE: To hold the lead specifically for WhatsApp sharing
    const [selectedLeadForWhatsappShare, setSelectedLeadForWhatsappShare] = useState(null);

    // NEW STATE FOR DEMO FOLLOW-UP TEMPLATES (the new requirement)
    const [showDemoFollowupTemplatesModal, setShowDemoFollowupTemplatesModal] = useState(false); // New modal state
    const [selectedDemoFollowupTemplate, setSelectedDemoFollowupTemplate] = useState(null); // Selected demo template

    // NEW: Store all WhatsApp templates for filtering by status
    const [allWhatsappTemplates, setAllWhatsappTemplates] = useState([]);

    // Remove unused wh_temps state
    // const [wh_temps, setwh_temps] = useState([]);

    // NEW STATE: For dynamic template filtering by lead status
    const [selectedLeadStatusForTemplates, setSelectedLeadStatusForTemplates] = useState("");

    // Constants for API report/post IDs
    const REPORT_ID_LEADS_DATA = 4;
    const POST_ID_ADD_LEAD = 1;
    const REPORT_ID_CALL_STATUSES = 10; // From Leads.js
    const REPORT_ID_LIVE_PRODUCTS = 12; // From Leads.js
    const REPORT_ID_SUBMIT_FOLLOWUP = 3; // From Leads.js
    const REPORT_ID_WHATSAPP_TEMPLATES = 13; // New constant for WhatsApp templates

    // Refs for DOM manipulation
    const viewDropdownRef = useRef(null);
    const callHistoryContentRef = useRef(null);

    // Placeholder for call duration - in web, we don't have direct call detection like RN.
    // For this implementation, we'll assume a default or let the user input if needed.
    // For simplicity, I'll use 0 or a placeholder for now, as direct call detection is not possible in web.
    const callDuration = useRef(0);


    // Function to navigate to Add Lead page
    const handleAddlead = () => {
        navigate('/Sidebar/Addlead');
    };

    // Callback to fetch lead data from API
    const fetchLeads = useCallback(async () => {
        setLoadingLeads(true);
        try {
            // Replace with your actual API call logic
            // console.log('Fetching leads for user_id:', Url.Url, user_id, REPORT_ID_LEADS_DATA);

            const response = await fetch(`${Url.Url}/get_report?data={"report_id":"${REPORT_ID_LEADS_DATA}","user_id":"${user_id}"}`);
// console.log('Fetch Leads Response:', response);
            if (!response.ok) throw new Error('Failed to fetch leads');
            const result = await response.json();
            console.log('Fetched Leads Data:', result);
            if (Array.isArray(result) && result.length > 0 && Array.isArray(result)) {
                // Parse Details for each lead
                // console.log('Parsing lead details from fetched data', result);
                const leadsWithParsedDetails = result.map(lead => ({
                    ...lead,
                    parsedDetails: lead.Details ? JSON.parse(lead.Details) : {}
                }));
                setLeads(leadsWithParsedDetails);
            } else {
                setLeads([]);
            }
        } catch (error) {
            setLeads([]);
        } finally {
            setLoadingLeads(false);
        }
    }, [user_id]);

    // NEW: useMemo to derive unique lead statuses directly from the 'leads' state
    const leadStatuses = useMemo(() => {
        const statuses = new Set();
        leads.forEach(lead => {
            if (lead.Status) {
                statuses.add(lead.Status);
            }
        });
        // Convert Set to Array and ensure 'All' is the first option
        return ['All', ...Array.from(statuses).sort()]; // Added sort for consistent order
    }, [leads]);


    // Effects for initial data fetch and event listeners
    useEffect(() => {
        if (user_id) {
            fetchLeads();
        }

        const handleClickOutside = (event) => {
            if (viewDropdownRef.current && !viewDropdownRef.current.contains(event.target)) {
                setShowViewDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [fetchLeads, user_id]);

    // Effect to refetch leads when navigating back to this page
    useEffect(() => {
        if (location.pathname === '/Sidebar/Manageleads') {
            fetchLeads();
        }
    }, [location.pathname, fetchLeads]);

    // Helper to get call history count
    const getCallHistoryCount = (lead) => {
        return lead?.parsedDetails?.tbl_calls?.length ?? 0;
    };

    // Handle file selection for import
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    // Handle lead import from Excel file
    const handleImportSubmit = async () => {
        if (!selectedFile) {
            alert('Please select an Excel file to import.');
            return;
        }

        setImporting(true);
        const reader = new FileReader();

        reader.onload = async (e) => {
            try {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];
                const json = XLSX.utils.sheet_to_to_json(worksheet);

                if (json.length === 0) {
                    alert('The selected Excel file is empty or has no data.');
                    setImporting(false);
                    return;
                }

                const leadsToImport = [];
                for (const row of json) {
                    // Normalize keys to expected format (e.g., 'Name' to 'name')
                    const leadToPost = {
                        name: row.Name || '',
                        companyname: row.Company || '',
                        email: row.Email || '',
                        mobile: row.Mobile ? String(row.Mobile) : '', // Ensure mobile is a string
                        address: row.Address || '',
                        productName: row.Product || '',
                        leadSource: row.LeadSource || '', // Ensure correct casing for leadSource
                        user_id: user_id,
                        postid: POST_ID_ADD_LEAD
                    };

                    // Basic validation
                    if (!leadToPost.name || !leadToPost.companyname || !leadToPost.email) {
                        console.warn('Skipping row due to missing required data (Name, Company, or Email):', row);
                        continue;
                    }
                    if (!leadToPost.email.includes('@')) {
                        console.warn('Skipping row due to invalid email format:', row);
                        continue;
                    }
                    leadsToImport.push(leadToPost);
                }

                if (leadsToImport.length === 0) {
                    alert('No valid leads found in the Excel file after validation.');
                    setImporting(false);
                    return;
                }

                // Group all valid leads into a single payload for one API call
                const payload = { data: { tbl_lead: leadsToImport } };

                try {
                    const response = await fetch(`${Url.Url}/post_data`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payload)
                    });

                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(`API error: ${JSON.stringify(errorData)}`);
                    }

                    alert('Leads imported successfully!');
                    setShowImportModal(false);
                    setSelectedFile(null);
                    fetchLeads(); // Refresh leads after successful import
                } catch (error) {
                    alert('Error during lead import: ' + error.message);
                    console.error('Lead import error:', error);
                }
            } catch (error) {
                alert('Error processing Excel file: ' + error.message);
                console.error('Excel processing error:', error);
            } finally {
                setImporting(false);
            }
        };
        reader.readAsArrayBuffer(selectedFile);
    };


    // Filter leads based on search query
    const searchFilteredLeads = useMemo(() => {
        if (!searchQuery.trim()) {
            return leads;
        }
        const lowerCaseQuery = searchQuery.toLowerCase();
        return leads.filter(lead =>
            lead.UserName?.toLowerCase().includes(lowerCaseQuery) ||
            lead.CompanyName?.toLowerCase().includes(lowerCaseQuery) ||
            lead.ContactPerson?.toLowerCase().includes(lowerCaseQuery) ||
            lead.Mobile?.toLowerCase().includes(lowerCaseQuery) ||
            lead.Address?.toLowerCase().includes(lowerCaseQuery) ||
            lead.LeadSource?.toLowerCase().includes(lowerCaseQuery)
        );
    }, [leads, searchQuery]);

    const filteredLeads = useMemo(() => {
        let result = searchFilteredLeads.filter(lead =>
            filterStatus === 'All' || lead.Status === filterStatus
        );
        if (filterStatus === 'Not Interested') {
            result = [
                ...result.filter(lead => lead.Status === 'Not Interested'),
                ...result.filter(lead => lead.Status !== 'Not Interested')
            ];
        }
        return result;
    }, [searchFilteredLeads, filterStatus]);

    // Calculate counts for each Status filter button
    const StatusCounts = useMemo(() => {
        const counts = { 'All': searchFilteredLeads.length };
        leadStatuses.forEach(status => {
            if (status !== 'All') {
                counts[status] = searchFilteredLeads.filter(lead => lead.Status === status).length;
            }
        });
        return counts;
    }, [searchFilteredLeads, leadStatuses]);

    // Handle editing a lead, navigate to Addlead page with lead data
    const handleEdit = (lead) => {
        const mappedLead = {
            id: lead.id,
            name: lead.ContactPerson || '',
            companyname: lead.CompanyName || '',
            email: lead.Email || '',
            mobile: lead.Mobile || '',
            address: lead.Address || '',
            productName: lead.ProductName || '',
            leadSource: lead.LeadSource || '',
            status: lead.Status || '', // Ensure status is passed for editing
            nextDate: lead.NextDate || '', // Ensure next_date is passed
        };
        navigate('/Sidebar/Addlead', { state: { editLead: mappedLead } });
    };

    // Function to create and download an Excel template for import
    const handleCreateTemplate = () => {
        const worksheetData = [{
            Name: '',
            Company: '',
            Email: '',
            Mobile: '',
            Address: '',
            Product: '',
            LeadSource: '' // Consistent casing with import logic
        }];
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'LeadsTemplate');
        XLSX.writeFile(workbook, 'Lead_Import_Template.xlsx');
    };

    /**
     * useMemo to dynamically generate table headers.
     * It will directly use the keys from the API data.
     * It includes essential exclusions for keys that hold complex objects or internal IDs,
     * which cannot be rendered directly as table cell content.
     */
    const headersToDisplay = useMemo(() => {
        // Keys that should NEVER be rendered directly as table cell content
        // because they are objects, arrays, or internal IDs.
        const keysToExclude = new Set([
            'id',
            'Details',       // This is the raw JSON string
            'parsedDetails', // This is the parsed JavaScript object from 'Details'
            'postid',
            'user_id',
            'IsActive',
            'Product', // Exclude Product if ReqProduct is used
            // Add any other keys here that you know will contain objects, arrays,
            // or sensitive internal data not meant for display.
        ]);

        const firstLead = leads[0];
        if (typeof firstLead !== 'object' || firstLead === null) {
            return []; // Safety check
        }

        // Reverting to dynamic header generation without fixed order
        // This will display headers based on the keys present in the first lead,
        // excluding the ones in `keysToExclude`.
        return Object.keys(firstLead)
            .filter(key => !keysToExclude.has(key))
            .map(key => ({ key, label: key })); // Label is simply the key name
    }, [leads]); // Recalculate only when 'leads' data changes


    // Utility function to format 24-hour time to 12-hour format
    const formatTimeTo12Hr = (timeStr) => {
        if (!timeStr || typeof timeStr !== 'string' || timeStr === 'N/A' || !timeStr.includes(':')) {
            return 'N/A';
        }
        try {
            const parts = timeStr.split(':');
            let hours = parseInt(parts[0], 10);
            let minutes = parseInt(parts[1], 10);

            if (isNaN(hours) || isNaN(minutes)) {
                return 'Invalid time';
            }

            const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
            const ampm = hours >= 12 ? 'PM' : 'AM';
            const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

            return `${formattedHours}:${formattedMinutes} ${ampm}`;
        } catch (error) {
            console.error("Error formatting time:", timeStr, error);
            return 'N/A';
        }
    };

    // Utility function to convert call duration from seconds to minutes and seconds
    const getCallDuration = (duration) => {
        const totalSeconds = parseInt(duration, 10);
        if (isNaN(totalSeconds) || totalSeconds < 0) return 'N/A';
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}m ${seconds}s`;
    };

    // Callback to generate PDF of call history
    const handleGeneratePdf = useCallback(() => {
        if (!callHistoryContentRef.current) {
            console.error("Call history content reference is null. Cannot generate PDF.");
            return;
        }

        const element = callHistoryContentRef.current;
        const leadName = selectedLeadForHistory?.CompanyName || selectedLeadForHistory?.ContactPerson || 'Lead';
        const filename = `${leadName}_Call_History.pdf`;

        const options = {
            margin: [10, 10, 10, 10],
            filename: filename,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: {
                scale: 2, // Increase scale for better quality text and icons
                logging: false,
                letterRendering: true,
                allowTaint: true, // Allow images from other origins (if any)
                useCORS: true, // Attempt to load images using CORS
            },
            jsPDF: {
                unit: 'mm',
                format: 'a4',
                orientation: 'portrait'
            },
            pagebreak: {
                mode: ['css', 'avoid-all'],
            }
        };

        html2pdf().from(element).set(options).save();
    }, [selectedLeadForHistory]);


    // =========================================================================
    // STATUS UPDATE AND FOLLOW-UP LOGIC
    // =========================================================================

    // Fetch Call Statuses
    useEffect(() => {
        const fetchCallStatuses = async () => {
            setLoadingStatuses(true);
            setStatusError(null);
            try {
                const response = await fetch(`${Url.Url}/get_report?data={"report_id":"${REPORT_ID_CALL_STATUSES}"}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();

                if (Array.isArray(result) && result.length > 0 && Array.isArray(result)) {
                    setCallStatuses(result);
                } else {
                    setStatusError('No status data found or unexpected format.');
                    setCallStatuses([]);
                }
            } catch (error) {
                console.error("Error fetching call statuses:", error);
                setStatusError('Failed to load call statuses.');
                setCallStatuses([]);
            } finally {
                setLoadingStatuses(false);
            }
        };

        fetchCallStatuses();
    }, []);

    // Fetch Live Products
    useEffect(() => {
        const fetchLiveProducts = async () => {
            setLoadingProducts(true);
            setProductError(null);
            try {
                const response = await fetch(`${Url.Url}/get_report?data={"report_id":"${REPORT_ID_LIVE_PRODUCTS}"}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                if (Array.isArray(result) && result.length > 0 && Array.isArray(result[0])) {
                    const apiProducts = result[0].map(item => ({ id: item.id, productname: item.Product_name }));

                    // Check if 'Other' already exists in the products fetched from the API
                    const hasOtherFromApi = apiProducts.some(
                        product => product.productname.toLowerCase() === "other"
                    );

                    let finalProducts = [...apiProducts];
                    if (!hasOtherFromApi) {
                        // Only add an "Other" option if it's not already present
                        finalProducts.push({ id: 'other', productname: 'Other' });
                    }
                    setLiveProducts(finalProducts);
                } else {
                    setProductError('No product data found or unexpected format.');
                    // If no product data, still ensure 'Other' is an option
                    setLiveProducts([{ id: 'other', productname: 'Other' }]);
                }
            } catch (error) {
                console.error("Error fetching live products:", error);
                setProductError('Failed to load products.');
                // Still include "Other" on error, as it's a critical fallback
                setLiveProducts([{ id: 'other', productname: 'Other' }]);
            } finally {
                setLoadingProducts(false);
            }
        };

        fetchLiveProducts();
    }, []);

    // MODIFIED: Fetch and filter WhatsApp Templates and Demo Follow-up Templates
    useEffect(() => {
        const fetchAllTemplates = async () => {
            setLoadingWhatsappTemplates(true); // Reusing this loading state as it covers both types
            setWhatsappTemplateError(null); // Reusing this error state
            try {
                const payload = user_id ? `{"user_id":"${user_id}","report_id":"${REPORT_ID_WHATSAPP_TEMPLATES}"}` : `{"report_id":"${REPORT_ID_WHATSAPP_TEMPLATES}"}`;
                const response = await fetch(`${Url.Url}/get_report?data=${payload}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();

                if (Array.isArray(result) && result.length > 0 && Array.isArray(result[0])) {
                    const fetchedTemplates = result[0];
                    setAllWhatsappTemplates(fetchedTemplates); // Store all fetched templates for filtering by status
                    // Filter templates based on status_template
                    const whatsappShareTemplates = fetchedTemplates.filter(
                        template => template.status_template === "WhatsApp Share"
                    );
                    setWhatsappTemplates(whatsappShareTemplates); // General WhatsApp Share templates
                } else {
                    setWhatsappTemplateError('No WhatsApp template data found or unexpected format.');
                    setWhatsappTemplates([]);
                    setAllWhatsappTemplates([]); // Clear the stored templates if no valid data
                }
            } catch (error) {
                console.error("Error fetching WhatsApp templates:", error);
                setWhatsappTemplateError('Failed to load WhatsApp templates.');
                setWhatsappTemplates([]);
                setAllWhatsappTemplates([]);
            } finally {
                setLoadingWhatsappTemplates(false);
            }
        };

        fetchAllTemplates();
    }, [user_id]);

    // Function to handle opening the status update modal
    const handleStatusUpdateClick = (lead) => {
        setSelectedLeadForStatusUpdate(lead);
        setSelectedStatus(null); // Reset selected status
        setNote(''); // Clear note
        setDate(new Date()); // Reset date
        setRating(0); // Reset rating
        setSelectedProduct(null); // Reset product
        setNewProductName(''); // Reset new product name
        setTempNewProductName(''); // Reset temporary product name
        setProductSearchTerm(''); // Clear product search
        setSelectedWhatsappTemplate(null); // Reset selected WhatsApp template
        setSelectedDemoFollowupTemplate(null); // Reset selected demo template

        setShowStatusUpdateModal(true);
    };

    // Modified onChangeDate to directly accept the selected Date object from react-datepicker
    const onChangeDate = (selectedDate) => {
        setDate(selectedDate);
    };

    // Filtered products based on productSearchTerm
    const filteredProducts = liveProducts.filter(product =>
        product.productname.toLowerCase().includes(productSearchTerm.toLowerCase())
    );

    // MODIFIED: Handle product selection in the modal
    const handleProductSelection = (product) => {
        setSelectedProduct(product);
        setNewProductName(''); // Clear previous new product name
        setTempNewProductName(''); // Clear temporary new product name

        setShowProductModal(false); // Always close the product selection modal immediately

        if (product.productname === "Other") {
            setShowNewProductPopup(true); // Open the new popup for "Other"
        }
        // If not "Other", no other popup is needed.
    };

    // MODIFIED: Original WhatsApp Template Selection (Now for templates within the status update flow)
    const handleWhatsappTemplateSelection = (template) => {
        setSelectedWhatsappTemplate(template); // Set the selected template
        setShowWhatsappTemplatesModal(false); // Close the templates modal
        setShowStatusUpdateModal(true); // Re-open the main status update modal
    };


    // NEW HANDLER: For Demo Follow-up Template Selection (Used by lead card WhatsApp Share button)
    const handleDemoFollowupTemplateSelection = (template) => {
        if (!selectedLeadForWhatsappShare?.Mobile) {
            alert('No Mobile: Mobile number not available for this lead.');
            return;
        }
        const number = selectedLeadForWhatsappShare.Mobile;
        const message = template.message;
        const url = `https://wa.me/+91${number}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
        setShowDemoFollowupTemplatesModal(false);
        setSelectedDemoFollowupTemplate(null);
        setSelectedLeadForWhatsappShare(null);
    };


    // Handler for the "OK" button in the new product name popup
    const handleNewProductNameOk = () => {
        if (!tempNewProductName.trim()) {
            alert('Please enter the new product name.'); // Using alert as per existing pattern
            return;
        }
        setNewProductName(tempNewProductName.trim()); // Save the temporary name to the official state
        setShowNewProductPopup(false); // Close the new product name popup
    };

    // Handler for the "Cancel" button in the new product name popup
    const handleNewProductNameCancel = () => {
        setSelectedProduct(null); // Deselect 'Other'
        setNewProductName(''); // Clear the new product name
        setTempNewProductName(''); // Clear temporary name
        setShowNewProductPopup(false); // Close the new product name popup
    };

    // MODIFIED: handleSubmitFollowUp - Adjusted for WhatsApp template
    const handleSubmitFollowUp = async () => {
        if (!selectedStatus) {
            alert('Please select a status before submitting.');
            return;
        }

        if (selectedStatus.status_type?.includes('Note') && !note.trim()) {
            alert('Note is required for this status.');
            return;
        }

        // Validate LiveProduct selection/input if status_type includes 'LiveProduct'
        if (selectedStatus.status_type?.includes('LiveProduct')) {
            // If "Other" is selected, and newProductName is empty, show alert
            if (selectedProduct?.productname === "Other" && !newProductName.trim()) {
                alert('Please enter a new product name for "Other".');
                return;
            }
            // If LiveProduct is required but nothing is selected/entered
            if (!selectedProduct) { // newProductName check is handled by the "Other" case above
                alert('Please select a product or enter a new one for "Other".');
                return;
            }
        }

        // NEW: If "WhatsApp Share" status is selected, ensure a template is chosen
        if (selectedStatus.status_type?.includes('share') && selectedStatus.statusname === "WhatsApp Share") {
            if (!selectedWhatsappTemplate) {
                alert('Please select a WhatsApp template for this status.');
                return;
            }
            // Also, open WhatsApp with the selected template if the lead has a mobile number
            if (selectedLeadForStatusUpdate?.Mobile && selectedWhatsappTemplate?.message) {
                const number = selectedLeadForStatusUpdate.Mobile;
                const message = selectedWhatsappTemplate.message;
                const url = `https://wa.me/+91${number}?text=${encodeURIComponent(message)}`;
                window.open(url, '_blank');
            } else {
                alert('Mobile number or template message not available for WhatsApp share.');
                return; // Prevent submission if WhatsApp cannot be shared
            }
        }


        let dateString = '';
        let timeString = '';
        // Removed formattedTime12Hr as it was primarily for WhatsApp share in this function

        if (selectedStatus.status_type?.includes('Datetime')) {
            const pad = (n) => (n < 10 ? '0' + n : n);
            const year = date.getFullYear();
            const month = pad(date.getMonth() + 1);
            const day = pad(date.getDate());
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const seconds = date.getSeconds();

            // 24-hour format for payload
            dateString = `${year}-${month}-${day} ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
            timeString = `${pad(hours)}:${pad(minutes)}`;

        } else {
            const now = new Date();
            const pad = (n) => (n < 10 ? '0' + n : n);
            const year = now.getFullYear();
            const month = pad(now.getMonth() + 1);
            const day = pad(now.getDate());
            const hours = now.getHours();
            const minutes = pad(now.getMinutes());
            const seconds = pad(now.getSeconds());

            // 24-hour format for payload
            dateString = `${year}-${month}-${day} ${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
            timeString = `${pad(hours)}:${pad(minutes)}`;
        }

        // Prepare payload
        const payload = {
            Date: dateString,
            Time: timeString,
            status: selectedStatus.statusname,
            Note: selectedStatus.status_type?.includes('Note') ? note.trim() : '',
            user_id: user_id,
            status_from: "Web",
            lead_id: selectedLeadForStatusUpdate?.id,
            duration: callDuration.current,
            report_id: REPORT_ID_SUBMIT_FOLLOWUP,
            rating: selectedStatus.status_type?.includes('star') ? rating : 0,
            Current_Product: selectedStatus.status_type?.includes('LiveProduct')
                ? (selectedProduct?.productname === "Other" ? newProductName.trim() : selectedProduct?.productname)
                : '',
            // NEW: Include WhatsApp template info if it was selected for this status
            Whatsapp_Template_Name: selectedStatus.status_type?.includes('share') && selectedStatus.statusname === "WhatsApp Share" && selectedWhatsappTemplate
                ? selectedWhatsappTemplate.templtname
                : '',
            Whatsapp_Template_Message: selectedStatus.status_type?.includes('share') && selectedStatus.statusname === "WhatsApp Share" && selectedWhatsappTemplate
                ? selectedWhatsappTemplate.message
                : '',
        };
        // console.log('Payload for follow-up submission:', JSON.stringify(payload));

        const encodedPayload = encodeURIComponent(JSON.stringify(payload));

        try {
            const response = await fetch(`${Url.Url}/get_report?data=${encodedPayload}`);
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(`API error: ${JSON.stringify(errorData)}`);
            }
            const result = await response.json();
            // console.log('Follow-up submission result:', result);

            fetchLeads(); // Refresh leads
        } catch (error) {
            console.error("Error submitting follow-up:", error);
            alert('Error submitting follow-up: ' + error.message);
        }
        finally {
            // Reset form state
            setShowStatusUpdateModal(false);
            setShowProductModal(false); // Close product modal
            setNote('');
            setSelectedStatus(null);
            setDate(new Date());
            setSelectedLeadForStatusUpdate(null);
            setRating(0);
            setSelectedProduct(null); // Reset selected product
            setNewProductName(''); // Reset new product name
            setTempNewProductName(''); // Reset temporary name
            setShowNewProductPopup(false); // Ensure new product popup is closed
            setProductSearchTerm(''); // Clear product search term
            setSelectedWhatsappTemplate(null); // Reset selected WhatsApp template
            setSelectedDemoFollowupTemplate(null); // Reset selected demo template
        }
    };

    const renderStars = () => {
        const stars = [];
        for (let i = 1; i <= 5; i++) {
            stars.push(
                <FontAwesomeIcon
                    key={i}
                    icon={i <= rating ? faStar : faStarEmpty}
                    onClick={() => setRating(i)}
                    style={{ color: i <= rating ? '#FFD700' : '#ccc', cursor: 'pointer', fontSize: '30px', margin: '0 5px' }}
                />
            );
        }
        return <div className="star-rating-container-web">{stars}</div>;
    };


    // Helper function to check if a lead's current status has the 's_share' status_type
    const doesLeadStatusHaveShareType = (lead) => {
        // Find the full status object from callStatuses based on lead.Status
        const currentLeadStatus = callStatuses.find(status => status.statusname === lead.Status);
        // Check if the status_type includes 's_share' (for the lead card button)
        return currentLeadStatus?.status_type?.includes('s_share');
    };
    const isMobileDevice = () => {
        return /Mobi|Android|iPhone/i.test(navigator.userAgent);
    };

    const displayStars = (rating) => {
        const totalStars = 5; // Assuming a 5-star rating system
        const stars = [];

        for (let i = 1; i <= totalStars; i++) {
            if (i <= rating) {
                // Render a solid star for ratings up to the given number
                stars.push(<FontAwesomeIcon key={i} icon={faStar} style={{ color: 'gold', fontSize: '20px', textAlign: 'center', alignItems: 'center' }} />);
            } else {
                // Render an empty star for the remaining stars (optional)
                stars.push(<FontAwesomeIcon key={i} icon={faStarEmpty} style={{ color: 'lightgray', fontSize: '20px', textAlign: 'center' }} />);
            }
        }
        return <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {stars}
        </div>;
    };
    const isIOS = () =>
        /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    const formatDateTime = (dateStr) => {
        if (!dateStr) return 'Invalid Date';

        // Try to split manually: supports both "YYYY-MM-DD HH:mm:ss" and "YYYY-MM-DDTHH:mm:ss"
        let parts = dateStr.trim().split(/[\sT]/); // Split on space or 'T'
        if (parts.length < 2) return 'Invalid Date';

        const [datePart, timePart] = parts;
        const [year, month, day] = datePart.split('-').map(Number);
        const [hour, minute, second] = timePart.split(':').map(Number);

        // Use Date.UTC to avoid local offset issues
        const date = new Date(year, month - 1, day, hour, minute, second);
        if (isNaN(date)) return 'Invalid Date';

        if (isIOS()) {
            // iOS: return yyyy-MM-dd
            return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        } else {
            // Android and others: full format
            const d = String(day).padStart(2, '0');
            const m = String(month).padStart(2, '0');
            const y = year;

            let h = date.getHours();
            const min = String(date.getMinutes()).padStart(2, '0');
            const sec = String(date.getSeconds()).padStart(2, '0');
            const ampm = h >= 12 ? 'PM' : 'AM';
            h = h % 12 || 12;
            h = String(h).padStart(2, '0');

            return `${d}-${m}-${y} ${h}:${min}:${sec} ${ampm}`;
        }
    };

    // NEW: Function to get status color for CSS variable
    const getStatusColor = (status) => {
        if (!status) return '#607D8B'; // default
        switch (status.toLowerCase()) {
            case 'follow-up': return '#4CAF50';
            case 'demo request': return '#2196F3';
            case 'not interested': return '#F44336';
            case 'phone not lifted': return '#FF9800';
            case 'wrong number': return '#9C27B0';
            case 'whatsapp share': return '#00BCD4';
            case 'completed': return 'linear-gradient(to right, #2196F3, #0D47A1)';
            case 'talktohead': return 'linear-gradient(to right, #004d40, #00796B)';
            case 'demo follow-up': return 'linear-gradient(to right, #00bfa5, #0288d1)';
            default: return '#607D8B';
        }
    };

    // =========================================================================
    // RENDER
    // =========================================================================

    return (
        <div className="manage-leads-container" >
            {/* Header Section */}
            <div className="lead-header">
                <h2 className="lead-title">Manage Leads</h2>

                <div className="lead-actions">
                    <div className="lead-search-container">
                        <FontAwesomeIcon icon={faSearch} className="search-icon" />
                        <input
                            type="text"
                            className="lead-search"
                            placeholder="Search leads..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>

                    <button className="lead-button addd import" onClick={() => setShowImportModal(true)}>
                        Import
                    </button>
                    <button className="lead-button off_add addd" onClick={handleAddlead}>
                        + Add Lead
                    </button>
                    <button
                        className="lead-button addd view-toggle"
                        onClick={() => setShowViewDropdown(!showViewDropdown)}
                    >
                        <FontAwesomeIcon icon={viewType === 'table' ? faTable : faThLarge} />
                    </button>
                    {/* View Toggle Dropdown */}
                    <div className="view-toggle-dropdown-container" ref={viewDropdownRef}>

                        {showViewDropdown && (
                            <div className="view-dropdown-content">
                                <button
                                    onClick={() => { setViewType('table'); setShowViewDropdown(false); }}
                                    className={viewType === 'table' ? 'active' : ''}
                                >
                                    <FontAwesomeIcon icon={faTable} /> Table View
                                </button>
                                <button
                                    onClick={() => { setViewType('box'); setShowViewDropdown(false); }}
                                    className={viewType === 'box' ? 'active' : ''}
                                >
                                    <FontAwesomeIcon icon={faThLarge} /> Box View
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Status Filter Section */}
            <div className="lead-filters-container">
                {leadStatuses.map(status => (
                    <button
                        key={status}
                        className={`lead-filter-button ${filterStatus === status ? 'active' : ''}`}
                        onClick={() => setFilterStatus(status)}
                    >
                        <span className="filter-status-count-bubble">
                            {StatusCounts[status] !== undefined ? StatusCounts[status] : 0}
                        </span>
                        <span className="filter-status-text">{status}</span>
                    </button>
                ))}
            </div>
            {viewType === 'table' ? (
                <div className="lead-table-wrapper">
                    <table className="lead-table">
                        <thead>
                            <tr>
                                {/* Dynamically generated table headers */}
                                {headersToDisplay.map(header => (
                                    <th key={header.key} className='lead_head'>{header.label}</th>
                                ))}
                                <th className='lead_head'>History</th>
                                <th className='lead_head'>Edit Lead</th>
                                <th className='lead_head'>Update Status</th> {/* New Header */}
                            </tr>
                        </thead>
                        <tbody>
                            {loadingLeads ? (
                                <tr>
                                    <td colSpan={headersToDisplay.length + 3} className="lead-no-data">
                                        <div className="spinner"></div>
                                        <p>Loading leads...</p>
                                    </td>
                                </tr>
                            ) : filteredLeads.length > 0 ? (
                                filteredLeads.map((lead) => (
                                    <tr key={lead.id}>
                                        {headersToDisplay.map(header => (
                                            <td key={`${lead.id}-${header.key}`} className='lead_td'>
                                                {/* Special handling for 'Status' and 'Next_Date' for display */}
                                                {header.key === 'Status' ? (
                                                    <span className={`lead-status ${lead.Status?.toLowerCase().replace(/\s/g, '-')}`}>
                                                        {lead.Status}
                                                    </span>
                                                ) : header.key === 'NextDate' && lead.NextDate ? (
                                                    formatDateTime(lead.NextDate)
                                                ) : header.key === 'CallTime' && lead.CallTime ? (
                                                    formatTimeTo12Hr(lead.CallTime)
                                                ) : (
                                                    // Display the value based on the header's key
                                                    // Use nullish coalescing (??) for better handling of undefined/null
                                                    lead[header.key] ?? 'N/A'
                                                )}
                                            </td>
                                        ))}
                                        <td className='lead_td'>
                                            <button
                                                className="action-icon-button"
                                                onClick={() => {
                                                    setSelectedLeadForHistory(lead);
                                                    setShowCallHistory(true);
                                                }}
                                                title="View Call History"
                                            >
                                                <FontAwesomeIcon icon={faHistory} />
                                            </button>
                                        </td>
                                        <td className='lead_td'>
                                            <button onClick={() => handleEdit(lead)} className='action-icon-button' title="Edit Lead">
                                                <FontAwesomeIcon icon={faEdit} />
                                            </button>
                                        </td>
                                        {/* New Status Update Button for Table View */}
                                        <td className='lead_td'>
                                            <button
                                                onClick={() => handleStatusUpdateClick(lead)}
                                                className='action-icon-button'
                                                title="Update Status"
                                            >
                                                <FontAwesomeIcon icon={faTag} />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={headersToDisplay.length + 3} className="lead-no-data">
                                        {searchQuery || filterStatus !== 'All'
                                            ? "No leads match your current search and filter criteria."
                                            : "No leads available. Try adding a new lead or importing from Excel!"
                                        }
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="lead-boxes-container" style={{ height: 'calc(100vh - 160px)', width: '100%', overflow: 'hidden' }}>
                    {loadingLeads ? (
                        <div className="lead-no-data-box">
                            <div className="spinner"></div>
                            <p>Loading leads...</p>
                        </div>
                    ) : filteredLeads.length > 0 ? (
                        <AutoSizer>
                            {({ height, width }) => {
                                const BOX_MIN_WIDTH = 310;
                                const GAP = 8;
                                const columnCount = Math.max(1, Math.floor(width / BOX_MIN_WIDTH));
                                const rowCount = Math.ceil(filteredLeads.length / columnCount);
                                // Ensure total width including gaps does not overflow
                                const boxWidth = Math.floor((width - GAP * (columnCount - 1)) / columnCount);
                                const boxHeight = 435;
                                return (
                                    <Grid
                                        columnCount={columnCount}
                                        columnWidth={boxWidth}
                                        height={height}
                                        rowCount={rowCount}
                                        rowHeight={boxHeight + GAP}
                                        width={width}
                                    >
                                        {({ columnIndex, rowIndex, style }) => {
                                            const index = rowIndex * columnCount + columnIndex;
                                            if (index >= filteredLeads.length) return null;
                                            const lead = filteredLeads[index];
                                            const statusColor = getStatusColor(lead.Status);
                                            // Stretch last column to fill remaining space
                                            let cellStyle = { ...style, padding: 8, boxSizing: 'border-box', height: boxHeight };
                                            if (columnIndex === columnCount - 1) {
                                                const usedWidth = (boxWidth + GAP) * (columnCount - 1);
                                                cellStyle.width = width - usedWidth;
                                            }
                                            return (
                                                <div
                                                    key={lead.id}
                                                    style={cellStyle}
                                                >
                                                    <div
                                                        className={`lead-box status-${lead.Status ? lead.Status.toLowerCase().replace(/\s+/g, '-') : 'default'}`}
                                                        style={{
                                                            height: '100%',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'space-between',
                                                            '--status-color': statusColor,
                                                        }}
                                                    >
                                                        <div className="lead-box-actions">
                                                            <button
                                                                onClick={() => handleStatusUpdateClick(lead)}
                                                                className='action-icon-button'
                                                                title="Update Status"
                                                            >
                                                                <FontAwesomeIcon icon={faTag} size="lg" />
                                                            </button>
                                                            <button
                                                                className="action-icon-button"
                                                                onClick={() => {
                                                                    setSelectedLeadForHistory(lead);
                                                                    setShowCallHistory(true);
                                                                }}
                                                                title="View Call History"
                                                            >
                                                                <FontAwesomeIcon icon={faHistory} size="lg" /> History ({getCallHistoryCount(lead)})
                                                            </button>
                                                            <button onClick={() => handleEdit(lead)} className='action-icon-button' title="Edit Lead">
                                                                <FontAwesomeIcon icon={faEdit} size="lg" /> Edit
                                                            </button>

                                                            <span className={`lead-status ${lead.Status?.toLowerCase().replace(/\s/g, '-')}`}>{lead.Status}</span>
                                                        </div>
                                                        <div className="lead-box-body" style={{ flexGrow: 1, overflowY: 'auto', maxHeight: boxHeight }}>
                                                            <div className="lead-box-header">
                                                                <h3 className="lead-box-company">{lead.CompanyName || 'N/A'}</h3>
                                                            </div>
                                                            {headersToDisplay
                                                                .filter(header => header.key !== 'CompanyName' && header.key !== 'Status' && header.key !== 'Rating')
                                                                .map(header => (
                                                                    <p
                                                                        key={`${lead.id}-${header.key}`}
                                                                        className={
                                                                            header.key === 'Mobile' ? 'Mobile' :
                                                                                header.key === 'Address' ? 'Address' :
                                                                                    header.key === 'CompanyName' ? 'company' : ''
                                                                        }
                                                                    >
                                                                        <strong className={header.key === 'Mobile' ? 'Mobile' : header.key === 'Address' ? 'Address' : ''}>
                                                                            {header.label}:
                                                                        </strong>{' '}
                                                                        {header.key === 'NextDate' && lead.NextDate
                                                                            ? formatDateTime(lead.NextDate)
                                                                            : header.key === 'CallTime' && lead.CallTime
                                                                                ? formatTimeTo12Hr(lead.CallTime)
                                                                                : lead[header.key] ?? 'N/A'}
                                                                    </p>
                                                                ))}
                                                        </div>
                                                        {lead.Mobile && isMobileDevice() && (
                                                            <a
                                                                href={`tel:${lead.Mobile}`}
                                                                className='call-button'
                                                                title="Call Lead"
                                                            >
                                                                <FontAwesomeIcon icon={faPhone} size="sm" style={{ marginRight: '8px' }} />
                                                                Call
                                                            </a>
                                                        )}
                                                        {doesLeadStatusHaveShareType(lead) && (
                                                            <button
                                                                className="share-button"
                                                                onClick={() => {
                                                                    setSelectedLeadForWhatsappShare(lead);
                                                                    setSelectedLeadStatusForTemplates(lead.Status);
                                                                    setShowDemoFollowupTemplatesModal(true);
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faWhatsapp} size='lg' style={{ marginRight: '8px', color: '#25D366' }} />
                                                                WhatsApp Share
                                                            </button>
                                                        )}
                                                        {lead.Rating !== undefined && (
                                                            <div style={{ textAlign: 'center', marginTop: '10px' }}>
                                                                {displayStars(lead.Rating)}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        }}
                                    </Grid>
                                );
                            }}
                        </AutoSizer>
                    ) : (
                        <div className="lead-no-data-box">
                            <p>{searchQuery || filterStatus !== 'All'
                                ? "No leads match your current search and filter criteria."
                                : "No leads available. Try adding a new lead or importing from Excel!"}
                            </p>
                        </div>
                    )}
                </div>
            )}

            {/* Import Lead Modal */}
            {showImportModal && (
                <div className="call-history-modal-overlay">
                    <div className="call-history-modal-container">
                        <div className="modal-header-web">
                            <h2 className="modal-title-web">Import Leads from Excel</h2>
                            <button className="close-modal-button-web" onClick={() => setShowImportModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="modal-body-web">
                            <p>Please select an Excel file (.xlsx or .xls) to import.</p>
                            <input
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileChange}
                                className="file-input"
                            />
                            <button
                                className="lead-button primary"
                                onClick={handleImportSubmit}
                                disabled={!selectedFile || importing}
                            >
                                {importing ? 'Importing...' : 'Upload & Import'}
                            </button>
                            <button
                                className="lead-button secondary"
                                onClick={handleCreateTemplate}
                                disabled={importing}
                            >
                                Create Sheet Template
                            </button>

                            {importing && <p className="import-status-text">Importing leads, please wait...</p>}
                            {!selectedFile && <p className="file-hint-text">No file selected.</p>}
                        </div>
                    </div>
                </div>
            )}

            {/* Call History Modal */}
            {showCallHistory && (
                <div className="call-history-modal-overlay">
                    <div className="call-history-modal-container">
                        <div className="modal-header-web">
                            <h2 className="modal-title-web">
                                Call History ({getCallHistoryCount(selectedLeadForHistory)} calls)
                            </h2>
                            {/* PDF Generate Button */}
                            <button
                                className="modal-action-button-web generate-pdf-button"
                                onClick={handleGeneratePdf}
                                title="Generate PDF"
                            >
                                <FontAwesomeIcon icon={faFilePdf} /> Generate PDF
                            </button>
                            {/* Close Button */}
                            <button className="close-modal-button-web" onClick={() => setShowCallHistory(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        {/* The content that needs to be converted to PDF */}
                        <div className="modal-body-web" ref={callHistoryContentRef}>
                            {selectedLeadForHistory ? (
                                <div className="call-history-wrapper-web">
                                    <h3 className="lead-title-web">
                                        Call History for: {selectedLeadForHistory.CompanyName || selectedLeadForHistory.ContactPerson}
                                    </h3>
                                    {Array.isArray(selectedLeadForHistory.parsedDetails?.tbl_calls) &&
                                        selectedLeadForHistory.parsedDetails.tbl_calls.length > 0 ? (
                                        selectedLeadForHistory.parsedDetails.tbl_calls.map((call, index) => (
                                            <div key={index} className="call-history-item-web">
                                                <div className="timeline-column-web">
                                                    {index !== 0 && <div className="timeline-line-segment-web top"></div>}
                                                    <div className="timeline-dot-web"></div>
                                                    {index !== selectedLeadForHistory.parsedDetails.tbl_calls.length - 1 && <div className="timeline-line-segment-web bottom"></div>}
                                                </div>
                                                <div className="call-details-content-web">
                                                    <p className="call-status-web">
                                                        <FontAwesomeIcon icon={faInfoCircle} style={{ color: '#0a4f88' }} />{' '}
                                                        <strong>Status:</strong> {call.status}
                                                    </p>

                                                    <p className="call-date-web">
                                                        <FontAwesomeIcon icon={faCalendarAlt} style={{ color: '#0a4f88' }} />{' '}
                                                        <strong>Date:</strong> {call.Date}
                                                    </p>

                                                    <p className="call-date-web">
                                                        <FontAwesomeIcon icon={faCube} style={{ color: '#0a4f88' }} />{' '}
                                                        <strong>Product:</strong> {call.Current_Product || 'N/A'}
                                                    </p>

                                                    <p className="call-date-web">
                                                        <FontAwesomeIcon icon={faClock} style={{ color: '#0a4f88' }} />{' '}
                                                        <strong>Time:</strong> {formatTimeTo12Hr(call.Time)}
                                                        {call.callduration && (
                                                            <>
                                                                {'    '}
                                                                <FontAwesomeIcon icon={faHourglassHalf} style={{ color: '#0a4f88', marginLeft: '10px' }} />{' '}
                                                                <strong>Duration:</strong> {getCallDuration(call.callduration)}
                                                            </>
                                                        )}
                                                    </p>
                                                    {/* <p className="call-date-web">
                                                        <FontAwesomeIcon icon={faShareNodes} style={{ color: '#0a4f88' }} />{' '}
                                                        <strong>Status From:</strong> {call.status_from || 'N/A'}
                                                    </p> */}
                                                    <p className="call-note-web">
                                                        <FontAwesomeIcon icon={faStickyNote} style={{ color: '#0a4f88' }} />{' '}
                                                        <strong>Note:</strong> {call.Note || 'N/A'}
                                                    </p>

                                                    {call.rating > 0 && (
                                                        <div className="display-stars-container-web">
                                                            {[...Array(5)].map((_, i) => (
                                                                <FontAwesomeIcon
                                                                    key={`display-star-${i}`}
                                                                    icon={i < call.rating ? faStar : faStarEmpty}
                                                                    style={{ color: '#FFD700' }}
                                                                />
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="no-history-message-web">No call history available for this lead.</p>
                                    )}
                                </div>
                            ) : (
                                <p className="no-history-message-web">No lead selected for call history.</p>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Status Update/Follow-up Modal (Main Form) */}
            {showStatusUpdateModal && (
                <div className="modal-overlay-web">
                    <div className="modal-container-web">
                        <div className="modal-header-web">
                            <h2 className="modal-title-web">Update Status for {selectedLeadForStatusUpdate?.ContactPerson || 'Lead'}</h2>
                            <button className="close-modal-button-web" onClick={() => setShowStatusUpdateModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="modal-body-web">
                            <div
                                className="status-button-web"
                                onClick={() => setShowStatusModal(true)}
                            >
                                {selectedStatus ? selectedStatus.statusname : 'Select Status'}
                            </div>

                            {/* Conditionally render DateTimePicker trigger */}
                            {selectedStatus?.status_type?.includes('Datetime') && (
                                <label className="date-time-picker-label-web">
                                    Next Follow-up Date & Time:
                                    <DatePicker
                                        selected={date}
                                        onChange={onChangeDate}
                                        showTimeSelect
                                        dateFormat="Pp" // This includes both date and time
                                        className="date-time-input-web" // Apply your existing CSS class
                                    />
                                </label>
                            )}

                            {/* Conditionally render LiveProduct selection */}
                            {selectedStatus?.status_type?.includes('LiveProduct') && (
                                <>
                                    <div
                                        className="status-button-web"
                                        onClick={() => setShowProductModal(true)}
                                    >
                                        {selectedProduct
                                            ? selectedProduct.productname === "Other"
                                                ? `${newProductName || 'Enter Name'}`
                                                : selectedProduct.productname
                                            : 'Select Present Software'}
                                    </div>
                                </>
                            )}
                            {/* NEW: Conditionally render WhatsApp Share selection within Status Update Modal */}
                            {selectedStatus?.status_type?.includes('share') && selectedStatus.statusname === "WhatsApp Share" && (
                                <>
                                    <div
                                        className="status-button-web"
                                        onClick={() => {
                                            setSelectedLeadForWhatsappShare(selectedLeadForStatusUpdate); // Crucial: Set the lead for WhatsApp share
                                            setShowWhatsappTemplatesModal(true);
                                            setShowStatusUpdateModal(false); // Close main modal temporarily
                                        }}
                                    >
                                        {selectedWhatsappTemplate ? selectedWhatsappTemplate.templtname : 'Select WhatsApp Template'}
                                    </div>
                                    {selectedWhatsappTemplate && (
                                        <textarea
                                            className="input-note-web" // Reusing text area style
                                            value={selectedWhatsappTemplate.message}
                                            readOnly // Make it read-only
                                            rows="5" // Adjust rows as needed
                                            placeholder="Selected template message will appear here..."
                                            title="WhatsApp Template Message"
                                        />
                                    )}
                                </>
                            )}


                            {/* Conditionally render Note input */}
                            {selectedStatus?.status_type?.includes('Note') && (
                                <textarea
                                    className="input-note-web"
                                    placeholder="Enter Note"
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                    rows="3"
                                />
                            )}

                            {/* Conditionally render Star Rating */}
                            {selectedStatus?.status_type?.includes('star') && (
                                renderStars()
                            )}

                            <button className="submit-button-web" onClick={handleSubmitFollowUp}>
                                Submit
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Status Selection Modal */}
            {showStatusModal && (
                <div className="modal-overlay-web">
                    <div className="modal-container-web">
                        <div className="modal-header-web">
                            <h2 className="modal-title-web">Select Status</h2>
                            <button className="close-modal-button-web" onClick={() => setShowStatusModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="modal-body-web status-selection-body">
                            {loadingStatuses ? (
                                <p className="loading-message-web">Loading statuses...</p>
                            ) : statusError ? (
                                <p className="error-message-web">{statusError}</p>
                            ) : callStatuses.length > 0 ? (
                                callStatuses.map((statusItem, idx) => (
                                    <div
                                        key={statusItem.id || idx}
                                        className="status-option-web"
                                        onClick={() => {
                                            setSelectedStatus(statusItem);
                                            setShowStatusModal(false);
                                            setRating(0); // Reset rating when selecting new status
                                            setNote(''); // Clear note when selecting new status
                                            setSelectedProduct(null); // Reset selected product
                                            setNewProductName(''); // Reset new product name
                                            setTempNewProductName(''); // Reset temporary name
                                            setShowNewProductPopup(false); // Ensure new product popup is closed
                                            setSelectedWhatsappTemplate(null); // Reset selected WhatsApp template when status changes
                                        }}
                                    >
                                        {statusItem.statusname}
                                    </div>
                                ))
                            ) : (
                                <p className="no-data-message-web">No statuses available.</p>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Product Selection Modal (Full-screen for choosing product) */}
            {showProductModal && (
                <div className="modal-overlay-web">
                    <div className="modal-container-web">
                        <div className="modal-header-web">
                            <h2 className="modal-title-web">Select Present Software</h2>
                            <button className="close-modal-button-web" onClick={() => setShowProductModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="modal-body-web product-selection-body">
                            <input
                                type="text"
                                className="product-search-input-web"
                                placeholder="Search product..."
                                value={productSearchTerm}
                                onChange={(e) => setProductSearchTerm(e.target.value)}
                            />

                            {loadingProducts ? (
                                <p className="loading-message-web">Loading products...</p>
                            ) : productError ? (
                                <p className="error-message-web">{productError}</p>
                            ) : filteredProducts.length > 0 ? (
                                filteredProducts.map((productItem, idx) => (
                                    <div
                                        key={productItem.id || idx}
                                        className={`product-option-web ${selectedProduct?.id === productItem.id ? 'selected-product-option-web' : ''}`}
                                        onClick={() => handleProductSelection(productItem)}
                                    >
                                        <p className="product-option-text-web">{productItem.productname}</p>
                                    </div>
                                ))
                            ) : (
                                <p className="no-data-message-web">No products found.</p>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Popup Modal for "Other" product name input */}
            {showNewProductPopup && (
                <div className="modal-overlay-web">
                    <div className="modal-container-web small-modal">
                        <div className="modal-header-web">
                            <h2 className="modal-title-web">Enter New Software Name</h2>
                        </div>
                        <div className="modal-body-web">
                            <input
                                type="text"
                                className="input-web"
                                placeholder="Software Name"
                                value={tempNewProductName}
                                onChange={(e) => setTempNewProductName(e.target.value)}
                                autoFocus={true}
                            />
                            <div className="modal-actions-web">
                                <button
                                    className="button-web secondary-button"
                                    onClick={handleNewProductNameCancel}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="button-web primary-button"
                                    onClick={handleNewProductNameOk}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* WhatsApp Templates Selection Modal (Now used for "WhatsApp Share" type templates, triggered from status update modal) */}
            {showWhatsappTemplatesModal && (
                <div className="modal-overlay-web">
                    <div className="modal-container-web full-width-modal">
                        <div className="modal-header-web">
                            <h2 className="modal-title-web">Select WhatsApp Template</h2>
                            <button className="close-modal-button-web" onClick={() => setShowWhatsappTemplatesModal(false)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="modal-body-web">
                            {loadingWhatsappTemplates ? (
                                <p className="loading-message-web">Loading templates...</p>
                            ) : whatsappTemplateError ? (
                                <p className="error-message-web">{whatsappTemplateError}</p>
                            ) : whatsappTemplates.length > 0 ? (
                                whatsappTemplates.map((template) => (
                                    <div
                                        key={template.id}
                                        className="whatsapp-template-option-web"
                                        onClick={() => handleWhatsappTemplateSelection(template)}
                                    >
                                        <div className="template-preview-content">
                                            <strong>{template.templtname}</strong>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className="no-data-message-web">No WhatsApp templates found.</p>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* NEW: Demo Follow-up WhatsApp Templates Modal (filtered by status) */}
            {showDemoFollowupTemplatesModal && (
                <div className="modal-overlay-web">
                    <div className="modal-container-web full-width-modal">
                        <div className="modal-header-web">
                            <h2 className="modal-title-web">Select WhatsApp Template</h2>
                            <button className="close-modal-button-web" onClick={() => {
                                setShowDemoFollowupTemplatesModal(false);
                                setSelectedLeadForWhatsappShare(null);
                                setSelectedLeadStatusForTemplates('');
                                setSelectedDemoFollowupTemplate(null);
                            }}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="modal-body-web">
                            {loadingWhatsappTemplates ? (
                                <p className="loading-message-web">Loading templates...</p>
                            ) : whatsappTemplateError ? (
                                <p className="error-message-web">{whatsappTemplateError}</p>
                            ) : selectedDemoFollowupTemplate ? (
                                <>
                                    <div style={{ marginBottom: 10 }}>
                                        <button
                                            className="status-button-web"
                                            style={{ marginBottom: 10, width: '100%' }}
                                            onClick={() => setSelectedDemoFollowupTemplate(null)}
                                        >
                                            {selectedDemoFollowupTemplate.templtname}
                                        </button>
                                    </div>
                                    <textarea
                                        className="input-note-web"
                                        value={selectedDemoFollowupTemplate.message}
                                        readOnly
                                        rows="5"
                                        placeholder="Selected template message will appear here..."
                                        title="WhatsApp Template Message"
                                        style={{ marginTop: 10, marginBottom: 15 }}
                                    />
                                    <button
                                        className="submit-button-web"
                                        onClick={() => {
                                            if (!selectedLeadForWhatsappShare?.Mobile) {
                                                alert('No Mobile: Mobile number not available for this lead.');
                                                return;
                                            }
                                            const number = selectedLeadForWhatsappShare.Mobile;
                                            const message = selectedDemoFollowupTemplate.message;
                                            const url = `https://wa.me/+91${number}?text=${encodeURIComponent(message)}`;
                                            window.open(url, '_blank');
                                            setShowDemoFollowupTemplatesModal(false);
                                            setSelectedDemoFollowupTemplate(null);
                                            setSelectedLeadForWhatsappShare(null);
                                        }}
                                    >
                                        Submit
                                    </button>
                                </>
                            ) : (() => {
                                // Use allWhatsappTemplates for status-based filtering
                                const dynamicTemplates = allWhatsappTemplates.filter(
                                    template => template.status_template === selectedLeadStatusForTemplates
                                );
                                return dynamicTemplates.length > 0 ? (
                                    dynamicTemplates.map((templateItem, idx) => (
                                        <div
                                            key={templateItem.id || idx}
                                            className="whatsapp-template-option-web"
                                            onClick={() => setSelectedDemoFollowupTemplate(templateItem)}
                                        >
                                            <div className="template-preview-content">
                                                <strong>{templateItem.templtname}</strong>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p className="no-data-message-web">No templates found for this status.</p>
                                );
                            })()}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
